import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { OrnateFrame, Flourish } from "@/components/royal";

export default function Login() {
  const { login, demoLogin } = useAuth();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [demoLoading, setDemoLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email.trim());
    setLoading(false);
    if (!res.ok) setError(res.error);
  };

  const tryDemo = async () => {
    setError("");
    setDemoLoading(true);
    const res = await demoLogin();
    setDemoLoading(false);
    if (!res.ok) setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-sm ht-fade-up">
        <div className="flex flex-col items-center mb-8">
          <Logo className="h-16 w-auto object-contain" />
          <Flourish className="mt-6 w-40" />
        </div>
        <OrnateFrame className="p-8">
          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="ht-uppercase-label block mb-2">Username</label>
              <Input
                data-testid="login-email-input"
                type="text"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="rounded-sm h-11 bg-background/60"
                required
              />
            </div>
            {error && (
              <p data-testid="login-error" className="text-destructive text-sm">{error}</p>
            )}
            <Button
              data-testid="login-submit-button"
              type="submit"
              disabled={loading}
              className="w-full h-11 rounded-sm font-heading tracking-wide"
            >
              {loading ? "Entering..." : "Enter the Realm"}
            </Button>
            <div className="ht-flourish pt-1"><span className="text-[0.65rem] tracking-[0.2em] uppercase">or</span></div>
            <Button
              data-testid="demo-login-button"
              type="button"
              variant="outline"
              disabled={demoLoading}
              onClick={tryDemo}
              className="w-full h-11 rounded-sm font-heading tracking-wide border-gold/50 hover:border-gold"
            >
              {demoLoading ? "Summoning..." : "Try Demo Account"}
            </Button>
          </form>
        </OrnateFrame>
      </div>
    </div>
  );
}
